import { Directive } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusShellBottom], campus-shell-bottom',
})
export class ShellBottomDirective {
  constructor() {}
}
